import { createContext } from 'react';

export const ViewerControlsContext = createContext({ showControls: false, showViewAngle: false });

export function viewerAccess(user, internal = false) {
  const showControls = Boolean(user?.id && user.active !== false && (user.is_owner || user.permissions?.view_model_controls === true));
  return { showControls, showViewAngle: showControls && internal };
}
